import { WarningOutlined } from "@ant-design/icons";
import { Upload } from "antd";
import cx from "classnames";
import uploadStyles from "components/elements/upload/Upload.module.css";
import styles from "./Upload.module.css";
import { uploadButton } from "components/elements/upload/Upload.utils";
import get from 'lodash/get'

function UploadComponent({
  className = "",
  name = "",
  label = "",
  size = "middle",
  loading = false,
  beforeUpload = false,
  onChange = () => { },
  required,
  showUploadList = false,
  action = null,
  errors,
  touched
}) {

  console.log("🚀 ~ error:", errors)
  const hasError = get(errors, name)

  return (
    <div className={cx(styles.container, className)}>
      <div>
        {label && (
          <label className={cx("label", styles.label)} htmlFor={name}>
            {label}
            {required && <span className="error">*</span>}
          </label>
        )}
      </div>
      <Upload
        className={uploadStyles.containerSecond}
        showUploadList={showUploadList}
        beforeUpload={beforeUpload}
        onChange={onChange}
        action={action}
      >
        {uploadButton(loading)}
      </Upload>
      {touched && hasError && (
        <span className={cx("error", styles.error)}>
          <WarningOutlined /> {hasError}
        </span>
      )}
    </div>
  );
}

export default UploadComponent;
